import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

export class NoReuseOnParamChangeStrategy extends BaseRouteReuseStrategy {
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.data['reuseComponent'] && curr.data['reuseComponent']) {
      return true;
    }

    if (future.routeConfig === curr.routeConfig) {
      const futureParams = JSON.stringify(future.params || {});
      const currParams = JSON.stringify(curr.params || {});
      if (futureParams !== currParams) {
        return false;
      }
    }
    return super.shouldReuseRoute(future, curr);
  }
}
